module.exports = "/work-site/img/towerType.54cfba9d.png";